<template>
    <div>
        <form-dzxy 
        v-if="type==='1'" 
        :row="row" 
        @cancle="$emit('cancle')" 
        :procode="procode">
        </form-dzxy>

        <form-cns 
        v-if="type==='2'" 
        :row="row" 
        @cancle="$emit('cancle')" 
        :procode="procode">
        </form-cns>


        
        <form-wtht
        v-if="type==='3'" 
        :row="row" 
        @cancle="$emit('cancle')" 
        :procode="procode">
        </form-wtht>
    </div>
</template>

<script>
export default {
    components: {
        FormDzxy: () => import('./agreements/form-dzxy'),
        FormCns: () => import('./agreements/form-cns'),
        FormWtht: () => import('./agreements/form-wtht'),
    },
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        type:{
            type:String,
            default:''
        }
    },
    data: () => ({
        data: {},
    }),
    computed: {
        procode() {
            if(this.row.procode){
                return this.row.procode
            }else{
                return (this.row.zbprocode || '').substr(0, 17);
            }
           
        }
    },
    methods: {
        
    },
    created() {

    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
.pdf-content{ height:500px; position:relative; }
</style>
